import { useGetters, useMutations, useActions } from 'vuex-composition-helpers';
import getStore from '@ve/services/getStore/getStore';
import registerModule from '@ve/services/registerModule';

import TouristGroupModel, {
    NAMESPACE,
    type TouristGroupGetters,
    type TouristGroupMutations,
    type TouristGroupActions
} from '../model/TouristGroupStore';

export default (modelPrefix: string = '') => {
    const nameSpace = `${NAMESPACE}${modelPrefix}`;
    const store = getStore();
    registerModule.register(store, TouristGroupModel, nameSpace);
    const { touristGroup, touristGroupText } = useGetters<TouristGroupGetters>(nameSpace, ['touristGroup', 'touristGroupText']);
    const {
        setAdults,
        setAges,
        setInfants,
        setKids,
        setTouristsByRooms,
    } = useMutations<TouristGroupMutations>(nameSpace, ['setAdults', 'setAges', 'setInfants', 'setKids', 'setTouristsByRooms']);

    const {
        updateTouristGroup
    } = useActions<TouristGroupActions>(nameSpace, ['updateTouristGroup'])


    return {
        setAdults,
        setAges,
        setInfants,
        setKids,
        setTouristsByRooms,
        updateTouristGroup,
        touristGroup,
        touristGroupText,
    };
};